import React from 'react';
import './Footer.scss';

function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-container">
                <div className="footer-column">
                    <h4>Pages</h4>
                    <ul>
                        <li><a href="/">Accueil</a></li>
                    </ul>
                </div>
                <div className="footer-column">
                    <h4>À propos</h4>
                    <ul>
                        <li> <a
                            href="mailto:contact.thespot.mail@gmail.com"
                            className="email-link"
                        >
                            Contact
                        </a></li>
                    </ul>
                </div>

                {/* Colonne 2 : Mentions légales */}
                <div className="footer-column">
                    <h4>Mentions légales</h4>
                    <ul>
                        <li><a href="/legal/terms">Conditions d'utilisation</a></li>
                        <li><a href="/legal/privacy">Politique de confidentialité</a></li>
                    </ul>
                </div>

                {/* Colonne 3 : Installer l’app */}
                <div className="footer-column">
                    <h4>Installer l’app</h4>
                    <ul>

                        <li><a
                            href="https://apps.apple.com/fr/app"
                            className="appstore-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Télécharger sur l’App Store
                        </a></li>
                    </ul>
                </div>
            </div>

            {/* Optionnel : un petit bandeau en bas */}
            <div className="footer-bottom">
                <p>&copy; 2025 TheSpot – Tous droits réservés.</p>
            </div>
        </footer>
    );
}

export default Footer;
